<template>
  <div>
    <b-btn
      class="d-flex align-items-center text-primary px-4"
      variant="white"
      @click="modal = true"
    >
      <svg
        class="mr-2"
        width="18"
        height="15"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2814 4.40492C17.1903 4.30198 17.0601 4.24316 16.9234 4.24316H15.0484V2.55146C15.0484 2.28314 14.8332 2.06562 14.5678 2.06562H6.31973V1.48584C6.31973 1.21753 6.10456 1 5.83915 1H1.48059C1.21517 1 1 1.21753 1 1.48584L1.00058 14.181C0.999712 14.293 1.03691 14.4029 1.10813 14.4912C1.19941 14.6043 1.33615 14.67 1.48059 14.67H15.8887C16.1336 14.67 16.3394 14.4837 16.3664 14.2376L17.4011 4.78238C17.4161 4.64512 17.3726 4.50785 17.2814 4.40492ZM1.96118 1.97169H5.35857V2.55146C5.35857 2.81977 5.57375 3.0373 5.83916 3.0373H14.0872V4.24316H3.40307C3.17495 4.24316 2.97826 4.40527 2.93235 4.63119L1.96118 9.40758V1.97169ZM2.06998 13.6984H15.4583L16.3867 5.21488H3.7949L2.06998 13.6984Z"
          fill="#4F83E3"
        />
        <path
          d="M17.2814 4.40492L17.3937 4.30547L17.3937 4.30545L17.2814 4.40492ZM15.0484 4.24316H14.8984V4.39316H15.0484V4.24316ZM6.31973 2.06562H6.16973V2.21562H6.31973V2.06562ZM1 1.48584H0.85V1.48585L1 1.48584ZM1.00058 14.181L1.15058 14.1822L1.15058 14.181L1.00058 14.181ZM1.10813 14.4912L1.22489 14.397L1.22487 14.397L1.10813 14.4912ZM16.3664 14.2376L16.5155 14.2539V14.2539L16.3664 14.2376ZM17.4011 4.78238L17.252 4.76606V4.76607L17.4011 4.78238ZM5.35857 1.97169H5.50857V1.82169H5.35857V1.97169ZM1.96118 1.97169V1.82169H1.81118V1.97169H1.96118ZM14.0872 3.0373H14.2372V2.8873H14.0872V3.0373ZM14.0872 4.24316V4.39316H14.2372V4.24316H14.0872ZM2.93235 4.63119L3.07934 4.66108L3.07934 4.66106L2.93235 4.63119ZM1.96118 9.40758H1.81118L2.10817 9.43746L1.96118 9.40758ZM15.4583 13.6984V13.8484H15.5928L15.6074 13.7147L15.4583 13.6984ZM2.06998 13.6984L1.92298 13.6685L1.88641 13.8484H2.06998V13.6984ZM16.3867 5.21488L16.5358 5.2312L16.554 5.06488H16.3867V5.21488ZM3.7949 5.21488V5.06488H3.67233L3.6479 5.18499L3.7949 5.21488ZM16.9234 4.39316C17.0168 4.39316 17.1062 4.43335 17.1692 4.50438L17.3937 4.30545C17.2743 4.17061 17.1033 4.09316 16.9234 4.09316V4.39316ZM15.0484 4.39316H16.9234V4.09316H15.0484V4.39316ZM14.8984 2.55146V4.24316H15.1984V2.55146H14.8984ZM14.5678 2.21562C14.7488 2.21562 14.8984 2.36444 14.8984 2.55146H15.1984C15.1984 2.20184 14.9176 1.91562 14.5678 1.91562V2.21562ZM6.31973 2.21562H14.5678V1.91562H6.31973V2.21562ZM6.16973 1.48584V2.06562H6.46973V1.48584H6.16973ZM5.83915 1.15C6.02018 1.15 6.16973 1.29883 6.16973 1.48584H6.46973C6.46973 1.13623 6.18894 0.85 5.83915 0.85V1.15ZM1.48059 1.15H5.83915V0.85H1.48059V1.15ZM1.15 1.48584C1.15 1.29883 1.29955 1.15 1.48059 1.15V0.85C1.1308 0.85 0.85 1.13623 0.85 1.48584H1.15ZM1.15058 14.181L1.15 1.48584L0.85 1.48585L0.850577 14.181L1.15058 14.181ZM1.22487 14.397C1.17592 14.3363 1.14997 14.2603 1.15057 14.1822L0.850581 14.1799C0.849455 14.3257 0.8979 14.4695 0.991398 14.5854L1.22487 14.397ZM1.48059 14.52C1.38186 14.52 1.28791 14.4751 1.22489 14.397L0.991377 14.5853C1.11091 14.7335 1.29044 14.82 1.48059 14.82V14.52ZM15.8887 14.52H1.48059V14.82H15.8887V14.52ZM16.2172 14.2212C16.1985 14.3926 16.0558 14.52 15.8887 14.52V14.82C16.2115 14.82 16.4803 14.5748 16.5155 14.2539L16.2172 14.2212ZM17.252 4.76607L16.2172 14.2212L16.5155 14.2539L17.5502 4.7987L17.252 4.76607ZM17.1691 4.50436C17.2321 4.57547 17.2624 4.67065 17.252 4.76606L17.5502 4.79871C17.5698 4.61959 17.5131 4.44023 17.3937 4.30547L17.1691 4.50436ZM5.35857 1.82169H1.96118V2.12169H5.35857V1.82169ZM5.50857 2.55146V1.97169H5.20857V2.55146H5.50857ZM5.83916 2.8873C5.65812 2.8873 5.50857 2.73847 5.50857 2.55146H5.20857C5.20857 2.90107 5.48937 3.1873 5.83916 3.1873V2.8873ZM14.0872 2.8873H5.83916V3.1873H14.0872V2.8873ZM14.2372 4.24316V3.0373H13.9372V4.24316H14.2372ZM3.40307 4.39316H14.0872V4.09316H3.40307V4.39316ZM3.07934 4.66106C3.11127 4.50397 3.24737 4.39316 3.40307 4.39316V4.09316C3.10253 4.09316 2.84525 4.30657 2.78535 4.60132L3.07934 4.66106ZM2.10817 9.43746L3.07934 4.66108L2.78536 4.6013L1.81419 9.37769L2.10817 9.43746ZM1.81118 1.97169V9.40758H2.11118V1.97169H1.81118ZM15.4583 13.5484H2.06998V13.8484H15.4583V13.5484ZM16.2376 5.19856L15.3092 13.6821L15.6074 13.7147L16.5358 5.2312L16.2376 5.19856ZM3.7949 5.36488H16.3867V5.06488H3.7949V5.36488ZM2.21697 13.7283L3.94189 5.24477L3.6479 5.18499L1.92298 13.6685L2.21697 13.7283Z"
          fill="#4F83E3"
        />
      </svg>

      Create New Folder
    </b-btn>

    <b-modal
      v-model="modal"
      class="position-relative"
      lazy
      centered
      body-class="py-5"
      content-class="new-section-modal"
      size="lg"
      hide-footer
      hide-header
    >
      <h3 class="text-center font-weight-bold mb-12 px-0">
        Create New Folder
      </h3>

      <b-row>
        <b-col
          offset="2"
          cols="8"
        >
          <b-form @submit.prevent="onsubmit">
            <b-form-group
              class="estage-form-group"
              label="Enter Folder Name"
            >
              <b-input
                v-model="name"
                v-validate="'required'"
                name="name"
                :state="errors.has('name') ? false : null"
              />
            </b-form-group>

            <div class="text-center mt-5">
              <b-btn
                type="submit"
                variant="primary"
                class="font-weight-bold font-size-14 px-5"
                :disabled="loading"
              >
                <b-spinner
                  v-if="loading"
                  class="mr-2"
                  variant="light"
                  small
                />
                Create
              </b-btn>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'CreateFolderModal',
  data () {
    return {
      modal: false,
      name: '',
      loading: false
    }
  },
  computed: {
    ...mapState('dashboard', {
      folder: state => state.folder
    })
  },
  watch: {
    modal (val) {
      if (val) {
        this.name = ''
        this.loading = false
      }
    }
  },
  methods: {
    onsubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          axios.post('api/projects/categories', {
            name: this.name,
            parent_id: this.folder ? this.folder.id : 0
          })
            .then(({data}) => {
              this.$store.dispatch('dashboard/loadFolder', data.data.id)
              this.modal = false
            })
            .catch(error => {
              const errors = error.response.data.errors
              if (!errors.hasOwnProperty('name')) {
                this.$swal({
                  icon: 'warning',
                  iconColor: '#4F83E3',
                  toast: true,
                  position: 'top-right',
                  title: 'A folder with the same name already exists.',
                  showConfirmButton: false,
                  timer: 3000
                })
              }
              this.loading = false
            })
        }
      })
    }
  }
}
</script>